module.exports = {
    extension: {
        undefined: "Chrome is not found!",
        not_found: "Dường như bạn chưa cài extension!",
        update_please: "Hãy nhấn nút cập nhật!",
        not_allow_incognito: "Extension chưa được cho phép ở chế độ ẩn danh",
    },
    socket: {
        undefined: "Chưa khởi tạo socket!",
        cannot_connect: "Không kết nối được máy chủ socket!",
    },
    invalid_inputs: "Đầu vào chưa đúng!",
    imgOnly: "Chỉ cho phép upload ảnh jpg hoặc png!",
    session_timeout: "Phiên giao dịch hết hạn, bạn hạy đăng nhập lại!",
    contact_admin: "Đã có lỗi xảy ra, hãy liên hệ admin!",
};


// WEBPACK FOOTER //
// src/utils/api/sms.js